export default __webpack_public_path__ + "static/media/TL04.1.c6884599.mp3";